/* TCF stub, close button */

window.cpexCmp = { version: '3.0.0' }
window.didomiOnReady = window.didomiOnReady || []
window.didomiEventListeners = window.didomiEventListeners || []

window.cpexAddCMPCloseButton = function () {
  const targetEl = document.getElementById('didomi-notice') || document.getElementsByClassName('didomi-popup-notice-logo-container')[0] // For both banner and popup
  if (targetEl) {
    const closeButton = document.createElement('div')
    closeButton.textContent = '×'
    closeButton.style.cssText = 'z-index: 2147483641; position: absolute; top: 10px; right: 10px; width: 40px; height: 40px; cursor: pointer; font-size: 20pt; text-align: center; line-height: 40px;'
    closeButton.addEventListener('click', function () { Didomi.notice.hide() })
    targetEl.appendChild(closeButton)
  }
}

/* DIDOMI TCF STUB + BANNER LOADING */

if (!window.didomiLoaded) {
  window.gdprAppliesGlobally = true
  function a (e) {
    if (!window.frames[e]) {
      if (document.body && document.body.firstChild) { var t = document.body; var n = document.createElement('iframe'); n.style.display = 'none'; n.name = e; n.title = e; t.insertBefore(n, t.firstChild) }
      else { setTimeout(function () { a(e) }, 5) }
    }
  }
  function e (n, r, o, c, s) {
    function e (e, t, n, a) { if (typeof n !== 'function') { return } if (!window[r]) { window[r] = [] } var i = false
    if (s) { i = s(e, t, n) } if (!i) { window[r].push({ command: e, parameter: t, callback: n, version: a }) } }
    e.stub = true
    function t (a) {
      if (!window[n] || window[n].stub !== true) { return }
      if (!a.data) { return }
      var i = typeof a.data === 'string'
      var e
      try { e = i ? JSON.parse(a.data) : a.data } catch (t) { return }
      if (e[o]) { var r = e[o]; window[n](r.command, r.parameter, function (e, t) { var n = {}; n[c] = { returnValue: e, success: t, callId: r.callId }; a.source.postMessage(i ? JSON.stringify(n) : n, '*') }, r.version) }
    }
    if (typeof window[n] !== 'function') { window[n] = e; if (window.addEventListener) { window.addEventListener('message', t, false) } else { window.attachEvent('onmessage', t) } }
  }
  e('__tcfapi', '__tcfapiBuffer', '__tcfapiCall', '__tcfapiReturn'); a('__tcfapiLocator');

  function addCustomTemplate () {
    return window.cpexCmpTemplate ? '?target_type=notice&target=' + window.cpexCmpTemplate : '?target=' + document.location.hostname
  }

  (function (didomiKey, template) {
    var t = document.createElement('script')
    t.id = 'spcloader'
    t.type = 'text/javascript'
    t.async = true
    t.src = 'https://sdk.privacy-center.org/' + didomiKey + '/loader.js' + template
    var n = document.getElementsByTagName('script')[0]
    n.parentNode.insertBefore(t, n)
  })('9a8e2159-3781-4da1-9590-fbf86806f86e', addCustomTemplate())
  window.didomiLoaded = true
};

/* ADD CLOSE BUTTON */
if (typeof window.cpexCmpAllowCloseButton !== 'undefined' || window.location.href.indexOf('cpexCmpAllowCloseButton') !== -1) {
  window.didomiOnReady.push(window.cpexAddCMPCloseButton)
}
